import { render, staticRenderFns } from "./TableList.vue?vue&type=template&id=36dce70c&scoped=true"
import script from "./TableList.vue?vue&type=script&lang=js"
export * from "./TableList.vue?vue&type=script&lang=js"
import style0 from "./TableList.vue?vue&type=style&index=0&id=36dce70c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36dce70c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\projects\\web_h5\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('36dce70c')) {
      api.createRecord('36dce70c', component.options)
    } else {
      api.reload('36dce70c', component.options)
    }
    module.hot.accept("./TableList.vue?vue&type=template&id=36dce70c&scoped=true", function () {
      api.rerender('36dce70c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/P2_Page/Invite/components/TableList.vue"
export default component.exports